import { Box, Fade } from "@mui/material"
import React from "react"

const a11yPropsDisclaimerTabWrapper = title => {
  return {
    id: `disclaimer tab wrapper ${title}`,
    "aria-labelledby": `disclaimer tab ${title}`,
  }
}

const DisclaimerTabWrapper = ({ children, value, tab, currentLanguage }) => {
  return (
    <div
      {...a11yPropsDisclaimerTabWrapper(tab.title[currentLanguage])}
      hidden={value !== tab.index}
    >
      <Fade in={value === tab.index}>
        <Box p={4}>{children}</Box>
      </Fade>
    </div>
  )
}

export default DisclaimerTabWrapper
